var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('client-only',[_c('DualRingLoader',{attrs:{"color":'#2b2b2b',"size":64}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }